import { REPORT, DAILY_RANGE } from "./data";

const FACTS = [
  { k: "XAU/USD", v: "Single instrument · 100% of deals", id: "instrument" },
  { k: REPORT.deals.toLocaleString("en-US"), v: "Deals executed, Apr–Oct 2026", id: "deals" },
  { k: "London · New York", v: "Primary sessions, Monday to Friday", id: "sessions" },
  { k: `${DAILY_RANGE.low}–${DAILY_RANGE.high}%`, v: "Historical daily range (gross)", id: "range" },
];

const BOOK = [
  ["Instrument", "Spot gold, XAU/USD, quoted against the US dollar"],
  ["Execution", "A-book through a regulated third-party broker; real market fills"],
  ["Direction", "Long and short, predominantly intraday; no swap charges recorded in the period"],
  ["Holding period", "Short-horizon positions built around session liquidity"],
  ["Costs", "Zero commission account; spreads absorbed in the strategy result"],
];

export const GtaxTraded = () => (
  <section className="py-28 gx-line" data-testid="gtax-traded">
    <div className="gx-wrap grid lg:grid-cols-12 gap-14 items-start">
      <div className="lg:col-span-5">
        <p className="gx-eyebrow">What we trade</p>
        <h2 className="gx-serif text-4xl md:text-5xl mt-6">One market. Understood deeply.</h2>
        <p className="mt-6 text-[color:var(--mute)] leading-relaxed">
          The mandate trades a single, deep and globally liquid market: spot gold against the US dollar. Concentration is deliberate.
          It lets the desk specialise in the market's session rhythm, liquidity pockets and macro catalysts.
        </p>
        <div className="gx-photo mt-10 h-72"><img src="/gtax/bars.jpg" alt="Fine gold bullion bars" /></div>
      </div>
      <div className="lg:col-span-7">
        <div className="grid grid-cols-2 gap-px bg-[color:var(--line)]">
          {FACTS.map((f) => (
            <div key={f.id} className="bg-[color:var(--bg)] p-8" data-testid={`gtax-traded-${f.id}`}>
              <div className="gx-serif text-3xl gx-gold">{f.k}</div>
              <div className="mt-2 text-sm text-[color:var(--mute)]">{f.v}</div>
            </div>
          ))}
        </div>
        <dl className="mt-10 divide-y divide-[color:var(--line)] border-y border-[color:var(--line)]">
          {BOOK.map(([k, v]) => (
            <div key={k} className="grid grid-cols-[160px_1fr] gap-6 py-5">
              <dt className="gx-caps text-sm">{k}</dt>
              <dd className="text-[color:var(--mute)]">{v}</dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  </section>
);
